// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5OJBQ","top":"styles_top__28PZR"};